export const GEOAPIFY_API_KEY = "a3586552dd7949ee986ca4a7039be7c1";

export const ALL_FILTER_OPTIONS = [
  { value: "text", label: "Text", emojicon: "icon/solid#align-justify" },
  { value: "select", label: "Select", emojicon: "icon/solid#chevron-circle-down" },
  { value: "multi_select", label: "Multi select", emojicon: "icon/solid#list-ul" },
  { value: "number", label: "Number", emojicon: "icon/solid#hashtag" },
  { value: "date", label: "Date", emojicon: "icon/regular#calendar-plus" },
  { value: "url", label: "URL", emojicon: "icon/solid#link" },
  { value: "location", label: "Location", emojicon: "icon/solid#map-pin" },
  { value: "image", label: "Image", emojicon: "icon/solid#image" },
  { value: "file", label: "File", emojicon: "icon/solid#file" },

  // { value: "page_content", label: "Page content" },
  // { value: "location", label: "Location" },
  // { value: "plain_text", label: "Plain text" },
  // { value: "formatted_text", label: "Formatted text" },
  // { value: "phone", label: "Phone" },
  // { value: "person", label: "Person" },
  // { value: "space", label: "Space" },
  // { value: "video", label: "Video" },
  // { value: "created_by", label: "Created by" },
  // { value: "created_time", label: "Created time" },
  // { value: "last_edited_by", label: "Last edited by" },
  // { value: "last_edited_time", label: "Last edited time" }
];

export const ALL_FILTER_MEMBER_VISIBILITY = [
  { value: "card", label: "On profile card" },
  { value: "profile", label: "On profile" },
  { value: "panel", label: "On filter panel" },
  { value: "managers", label: "Managers only" }
];

export const ALL_FILTER_SPACE_VISIBILITY = [
  { value: "creation", label: "On post creation" },
  { value: "card", label: "On card" },
  { value: "page", label: "On page" },
  { value: "panel", label: "On filter panel" },
  { value: "managers", label: "Managers only" }
];

export const ALL_FILTER_MEMBER_FILE_VISIBILITY = [
  { value: "profile", label: "On profile" },
  { value: "managers", label: "Managers only" }
];

export const ALL_FILTER_SPACE_FILE_VISIBILITY = [
  { value: "creation", label: "On post creation" },
  { value: "page", label: "On page" },
  { value: "managers", label: "Managers only" }
];

const _selectSort = [
  { value: "manual", label: "Manual" },
  { value: "alphabetical", label: "Alphabetical" },
  { value: "reverse_alphabetical", label: "Reverse alphabetical" }
];

export const numberFormat = [
  { value: "number", label: "Number", icon: "🔢", symbol: "" },
  { value: "percent", label: "Percent", icon: "📊", symbol: "%" },
  { value: "usd", label: "US Dollar", icon: "🇺🇸", symbol: "$" },
  { value: "eur", label: "Euro", icon: "🇪🇺", symbol: "€" },
  { value: "cad", label: "Canadian Dollar", icon: "🇨🇦", symbol: "$" },
  { value: "gbp", label: "Pound", icon: "🇬🇧", symbol: "£" },
  { value: "sek", label: "Swedish Krona", icon: "🇸🇪", symbol: "kr" },
  { value: "rub", label: "Ruble", icon: "🇷🇺", symbol: "₽" },
  { value: "mxn", label: "Mexican Peso", icon: "🇲🇽", symbol: "$" },
  { value: "inr", label: "Rupee", icon: "🇮🇳", symbol: "₹" },
  { value: "aud", label: "Australian Dollar", icon: "🇦🇺", symbol: "$" },
  { value: "chf", label: "Franc", icon: "🇨🇭", symbol: "CHF" },
  { value: "nzd", label: "New Zealand Dollar", icon: "🇳🇿", symbol: "$" },
  { value: "brl", label: "Real", icon: "🇧🇷", symbol: "R$" },
  { value: "pln", label: "Zloty", icon: "🇵🇱", symbol: "zł" }
];

export const dateFormat = [
  { value: "full_date", label: "Full date", format: "DDD" },
  { value: "MM/DD/YYYY", label: "Month/Day/Year", format: "MM/dd/yyyy" },
  { value: "DD/MM/YYYY", label: "Day/Month/Year", format: "dd/MM/yyyy" },
  { value: "YYYY/MM/DD", label: "Year/Month/Day", format: "yyyy/MM/dd" }
];

const _decimalPlaces = [
  { value: "default", label: "Default" },
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" }
];

const locationOptions = [
  { value: "city_country", label: "City and Country" },
  { value: "country", label: "Country only" },
  { value: "full", label: "Full address" }
];

export const ALL_FILTER_PROPERTIES = {
  "select": {
    sort: _selectSort,
    default_value: "manual",
    show_options: true,
    label: "Sort"
  },
  "multi_select": {
    sort: _selectSort,
    default_value: "manual",
    show_options: true,
    label: "Sort"
  },
  "number": {
    format: numberFormat,
    default_value: "number",
    label: "Number format",
    decimalPlaces: _decimalPlaces
  },
  "date": {
    format: dateFormat,
    includeTime: true,
    default_value: "full_date"
  },
  "person": {
    limit: true
  },
  "space": {
    limit: true
  },
  "location": {
    label: "Format",
    format: locationOptions,
    default_value: "city_country"
  }
};

export function reorderOptions(array, from, to) {
  const newArray = array.slice();

  if (
    from < 0 ||
    from >= newArray.length ||
    to < 0 ||
    to >= newArray.length
  ) {
    return newArray;
  }

  const item = newArray.splice(from, 1)[0];
  newArray.splice(to, 0, item);

  return newArray.map((item, index) => ({
    ...item,
    sort_order: index
  }));
};

export const generateUniqueName = (baseName, data) => {
  let count = 0;
  let candidate = baseName;

  while (data.some(item => item.name.toLowerCase() === candidate.toLowerCase())) {
    count += 1;
    candidate = `${baseName} ${count}`;
  }

  return candidate;
};

export const generateKeyFromName = (name) => {
  return name
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_')
    .replace(/[^\w_]/g, '');
};

export const getOptionKey = (format) => {
  switch (format) {
    case "select":
    case "multi_select":
      return "sort";
    case "number":
    case "date":
    case "location":
      return "format";
    default:
      return "limit";
  }
};

export const getLocationFormat = (item, format) => {
  if (!item) return null;
  if (typeof item === "string") {
    return item;
  }
  if (format === "city_country") {
    return `${item.city}, ${item.country}`;
  } else if (format === "country") {
    return `${item.country}`;
  } else {
    return `${item.formatted}`;
  }
};

export const sortByName = (data, sortType = "manual") => {
  const array = Array.isArray(data) ? data : [];
  const compare = (a, b) =>
    a.name.toLowerCase().localeCompare(b.name.toLowerCase(), undefined, {
      numeric: true,
      sensitivity: 'base'
    });

  if (sortType === "alphabetical") {
    return [...array].sort(compare);
  }

  if (sortType === "reverse_alphabetical") {
    return [...array].sort((a, b) => compare(b, a));
  }

  return array.map((item, index) => ({
    ...item,
    sort_order: index
  }));
};

export const isUrl = (str) => {
  if (typeof str !== "string") return false;
  const pattern = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
  return pattern.test(str.trim());
};

export const getFilterColors = (theme) => {
  return [
    { name: "Red", value: theme.colors.red[1] },
    { name: "Pink", value: theme.colors.pink[1] },
    { name: "Grape", value: theme.colors.grape[1] },
    { name: "Violet", value: theme.colors.violet[1] },
    { name: "Indigo", value: theme.colors.indigo[1] },
    { name: "Blue", value: theme.colors.blue[1] },
    { name: "Cyan", value: theme.colors.cyan[1] },
    { name: "Teal", value: theme.colors.teal[1] },
    { name: "Green", value: theme.colors.green[1] },
    { name: "Lime", value: theme.colors.lime[1] },
    { name: "Yellow", value: theme.colors.yellow[1] },
    { name: "Orange", value: theme.colors.orange[1] },
    { name: "Gray", value: theme.colors.gray[3] },
    { name: "Default", value: "#f3f3f3" }
  ];
};

export const getNextAvailableColor = (theme, oldValues) => {
  const usedColors = oldValues.map(v => v.color);
  const allColors = getFilterColors(theme).filter(c => c.value !== "#f3f3f3");

  const availableColors = allColors.filter(c => !usedColors.includes(c.value));

  const source = availableColors.length > 0 ? availableColors : allColors;
  const randomColor = source[Math.floor(Math.random() * source.length)];

  return randomColor.value;
};

const conditionText = [
  { label: "Contains", value: "contains" },
  { label: "Starts with", value: "starts_with" },
  { label: "Ends with", value: "ends_with" },
  { label: "Is", value: "is" },
  { label: "Is not", value: "is_not" },
];

const conditionEmpty = [
  { label: "Is empty", value: "is_empty" },
  { label: "Is not empty", value: "is_not_empty" },
];

export const conditions = {
  text: [
    ...conditionText,
    ...conditionEmpty
  ],
  number: [
    { label: "=", value: "=" },
    { label: "≠", value: "!=" },
    { label: ">", value: ">" },
    { label: "<", value: "<" },
    { label: "≥", value: ">=" },
    { label: "≤", value: "<=" },
    ...conditionEmpty
  ],
  date: [
    { label: "Is", value: "is" },
    { label: "Before", value: "before" },
    { label: "After", value: "after" },
    ...conditionEmpty
  ],
  url: [
    ...conditionText,
    ...conditionEmpty
  ],
  location: [
    ...conditionText,
    ...conditionEmpty
  ]
};